import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { getRegistrationProfileEditPath } from '../../../../../../../../features/registration/profile/registration-profile-routing';
import { getPageHead } from '../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `profile-${params.profileId}-edit`,
        label: 'Edit',
        to: getRegistrationProfileEditPath(params.profileId),
      }),
    }) as const satisfies AggregateBreadcrumb,
  head: () => getPageHead('Edit Profile'),
});
